export const colors = {
  green: '#367B6E',
  lightGreen: '#A6DEAB',
  secondLightGreen: '#EFF5F3',
  blue: '#E6FAFF',
  red: '#ED4D4D',
  lightPeach: '#FFF1E7',
  lightBlue: '#EFF7FE',
  gray: '#EDF0F3',
  mutedGray: '#A39E9E',
  xLightGray: '#F2F2F2',
  xxLightGray: '#F7F7F7',
  darkGray: '#5F5F5F',
  black: '#000000',
  white: '#FFFFFF',
  lightYellow: '#FFF7E6',
  disabled: '#F5F5F5',
  surfaceMuted: '#F7F8FA',
} as const;
